<template>
  <DemoBase>
    <LoadingModal :show="response.loading"></LoadingModal>
  </DemoBase>
</template>

<script>
import DemoBase from "@/base_lib/demo/base/DemoBase";
import LoadingModal from "@/base_lib/components/container/LoadingModal"
import PageMixin from "@/base_lib/data/mixins/pageMixin"

export default {
  name: "LoadingModalDemo",
  components: {LoadingModal, DemoBase},
  mixins: [PageMixin],
  mounted() {
    this.loadingTest()
  }
}
</script>

<style scoped>

</style>